import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import placeholderImg from '../assests/services_image_1.jpg';
import cubesatImg from '../assests/services_image_2.jpg';
import ucavImg from '../assests/services_image_3.jpg';
import radioImg from '../assests/services_image_4.jpg';
import robotImg from '../assests/services_image_1.jpg';

const industries = [
  {
    id: 1,
    title: "Mission Control Software for CubeSat",
    image: cubesatImg,
    placeholderImage: placeholderImg,
    link: "/products/products1"
  },
  {
    id: 2,
    title: "Mission Control Software for UCAV",
    image: ucavImg,
    placeholderImage: placeholderImg,
    link: "/products/products3"
  },
  {
    id: 3,
    title: "Software-Defined Radios for CubeSat Applications",
    image: radioImg,
    placeholderImage: placeholderImg,
    link: "/products/products2"
  },
  {
    id: 4,
    title: "Agastya : A DNN Robot",
    image: robotImg,
    placeholderImage: placeholderImg,
    link: "/products/products4"
  }
];

const Industry = () => {
  return (
    <div className="w-full">
      {/* Top Bar - Responsive padding and text size */}
      <div className="w-full p-4 sm:p-8 md:p-12 lg:p-14 bg-white">
      <div className="w-full flex justify-center items-center relative px-4 sm:px-8 md:px-16 lg:px-24">
      <h1 
      className="font-nova-square text-4xl sm:text-5xl md:text-6xl font-bold text-center text-gray-800 after:absolute after:top-10 after:sm:top-16 after:lg:top-16 after:2xl:top-16 after:bottom-0 after:left-0 after:w-[100%] after:h-1 after:bg-blue-700 after:transform after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300" 
      data-aos="fade-up">
        Our Products
        {/* <div className="absolute w-full h-1 top-full left-0 mt-1 bg-blue-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div> */}
      </h1>
      </div>
    </div>

      {/* Service Items - Responsive grid */}
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-0.5 bg-gray-50 ">
      {industries.map((industry) => (
        <div key={industry.id} className="relative group">
          <Link to={industry.link} className="relative inset-0 z-5 block" aria-label={industry.title}>
            {/* Image Container */}
            <div className="relative">
              <div className="aspect-[4/5] sm:aspect-[480/700] relative overflow-hidden">
                {/* Placeholder image */}
                <img 
                  src={industry.placeholderImage} 
                  alt="" 
                  className="relative z-[-5] opacity-0"
                />
                {/* Main image */}
                <div 
                  className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                  style={{ backgroundImage: `url(${industry.image})` }}
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 right-full bg-white/60 group-hover:right-0 transition-all duration-500 ease-[cubic-bezier(0.040,0.630,0.000,0.965)]" />
              </div>
              
              {/* Title - Responsive padding and text size */}
              <div className="absolute top-0 left-0 right-0 p-6 sm:p-8 md:p-10 lg:px-12 pb-16 sm:pb-20 md:pb-24 bg-gradient-to-b from-white/90 to-transparent">
                <h3 className="font-nova-square text-xl sm:text-2xl md:text-3xl text-gray-800 max-w-[320px] group-hover:text-gray-900 transition-colors">
                  {industry.title}
                </h3>
              </div>
              
              {/* View More - Responsive padding and text size */}
              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 md:p-10 lg:p-12 pt-16 sm:pt-20 md:pt-24 bg-gradient-to-t from-white/90 to-transparent">
                <span className="inline-block relative border border-yellow-400 rounded-full px-4 sm:px-5 py-2 pr-10 sm:pr-12 text-gray-800 uppercase text-xs sm:text-sm tracking-wider group-hover:text-gray-900 group-hover:border-gray-900 transition-colors">
                  <span className="text-yellow-400 group-hover:text-gray-900">View More</span>
                  <ChevronRight className="w-4 h-4 absolute text-yellow-400 right-4 sm:right-5 top-1/2 -translate-y-1/2 transition-all duration-300 group-hover:right-3 sm:group-hover:right-4 group-hover:text-gray-900" />
                </span>
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
    </div>
  );
};

export default Industry;